import React from 'react';

import { IconContext } from 'react-icons';

import styles from './IconsProvider.less';

interface IconProviderProps {
  children?: React.ReactNode;
}
const IconProvider: React.FC<IconProviderProps> = ({ children }) => {
  const value = React.useMemo(() => ({ className: styles.reactIcons }), []);
  return <IconContext.Provider value={value}>{children}</IconContext.Provider>;
};

export default IconProvider;
